module.exports = __webpack_public_path__ + "static/media/baixando.bbf3f9a1.svg";